export enum EventType {
  Impressions = 'impressions',
  AddToCart = 'addToCart',
  RemoveFromCart = 'removeFromCart',
  ProductClick = 'productClick',
  Detail = 'detail',
  Checkout = 'checkout',
  Purchase = 'purchase',
  CustomTrackingUrl = 'Custom Tracking URL',
  VirtualTrackingUrl = 'VirtualTrackingUrl',
  PolicyNumber = 'Policy Number',
  QuotePrice = 'Quote Price',
  QuoteId = 'Quote ID',
  SplitTest = 'Split Test',
  FormSubmit = 'form_submit',
  UpdateQuote = 'update_quote',
  EditTrip = 'edit_trip_form',
  ApplyPromotion = 'apply_promotion',
  QuoteEmail = 'quote_email',
  SubmitPayment = 'submit_payment',
  Form = 'form',
  Interaction = 'interaction',
}

export enum GtmApp {
  Public = 'public',
  CMS = 'cms',
}

export enum GtmPage {
  PurchasePath = 'purchase_path',
  HomePage = 'homepage',
  Quote = 'quote',
  Payment = 'payment',
}

export enum GtmVirtual {
  Empty = '',
  Home = '/',
  AMT = '/annual-travel-insurance',
  Plans = '/quote/plans',
  Options = '/quote/options',
  Details = '/quote/details',
  Payment = '/quote/payment',
  Receipt = '/confirmation',
}

export enum CheckoutStep {
  Destinations = 1,
  Dates = 2,
  Ages = 3,
  Plans = 4,
  Options = 5,
  Details = 6,
  Payment = 7,
}

export enum ProductCategory {
  QuotesDestinations = 'Quotes/Destinations',
  QuotesDatesDuration = 'Quotes/Dates/Duration',
  QuotesDatesTravelPeriod = 'Quotes/Dates/Travel-period',
  QuotesDatesLeadtime = 'Quotes/Dates/Lead-time',
  QuotesTravellerAdults = 'Quotes/Traveller/Adults',
  QuotesTravellerKids = 'Quotes/Traveller/Kids',
  QuotesTravellerAge = 'Quotes/Traveller/Age',
  Plan = 'Quote',
  Options = 'Options',
  OptionsSpecifiedItems = 'Options/Specified-items',
  // OptionsDonation = 'Options/Donation',
}
